const convertEnergy = (energyValue: number, energyThreshold = 10000): [number, 'kW' | 'MW'] => {
  if (energyValue > energyThreshold) return [energyValue / 1000, 'MW'];

  return [energyValue, 'kW'];
};

const convertEnergyTrendsData = (energyValue: number): [number, 'kW' | 'MW' | 'GW'] => {
  const GIGA_VALUE = 1_000_000;
  const MIN_MEGA_VALUE = 100_000;
  const MEGA_VALUE = 1_000;

  if (energyValue >= GIGA_VALUE) return [energyValue / GIGA_VALUE, 'GW'];
  if (energyValue >= MIN_MEGA_VALUE) return [energyValue / MEGA_VALUE, 'MW'];

  return [energyValue, 'kW'];
};

const convertEnergyNewTrendsData = (energyValue: number): [number, 'kW' | 'MW' | 'GW'] => {
  const GIGA_VALUE = 1_000_000;
  const MEGA_VALUE = 1_000;

  if (energyValue >= GIGA_VALUE) return [energyValue / GIGA_VALUE, 'GW'];
  if (energyValue >= MEGA_VALUE) return [energyValue / MEGA_VALUE, 'MW'];

  return [energyValue, 'kW'];
};

export { convertEnergy, convertEnergyTrendsData, convertEnergyNewTrendsData };
